import classnames from "classnames";
import * as React from "react";
import List from "../list/index";
class PopupList extends React.Component {
    constructor(props) {
        super(props);
        this.ref = React.createRef();
        this.windowMouseUpEventListener = this.onMouseUp.bind(this);
        this.state = { selected: 0 };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        if ("selected" in nextProps && nextProps.selected !== prevState.selected) {
            return { selected: nextProps.selected };
        }
        return null;
    }
    componentDidMount() {
        window.addEventListener("mouseup", this.windowMouseUpEventListener);
    }
    componentWillUnmount() {
        window.removeEventListener("mouseup", this.windowMouseUpEventListener);
    }
    render() {
        const { prefixCls, className } = this.props;
        const wrapCls = classnames(prefixCls, className);
        return (<div className={wrapCls}>
        <div className={`${prefixCls}-content`}>
          {this.props.header && <div className={`${prefixCls}-header`}>{this.props.header}</div>}
          <div ref={this.ref} onMouseUp={e => {
            e.preventDefault();
            e.stopPropagation();
        }}>
            <List>
              {this.props.content.map((e, i) => (<List.Item className={`${this.state.selected === i ? "pm-popup-list-selected" : ""}`} key={i} onClick={e => {
            e.preventDefault();
            e.stopPropagation();
            this.setState({ selected: i });
            this.props.onTap(e, i, true);
        }}>
                  {e}
                </List.Item>))}
            </List>
          </div>
          {this.props.footer && <div className={`${prefixCls}-footer`}>{this.props.footer}</div>}
        </div>
      </div>);
    }
    /**
     * Cancel:
     * detect click outside of ref element, return current selected element
     */
    onMouseUp(event) {
        if (this.ref == null || this.ref.current == null) {
            return;
        }
        if (event.target != null && this.ref.current.contains(event.target)) {
            return;
        }
        for (let i = 0; i < this.props.content.length; i++) {
            if (i === this.state.selected) {
                const e = this.props.content[i];
                this.props.onTap(e, i, false);
            }
        }
    }
}
PopupList.defaultProps = {
    prefixCls: "pm-popup-list",
};
export default PopupList;
